import { DefaultsConstants } from './defaults.constants'
import { IDefaultsAction, IDefaultsState } from './defaults.types'

export const initialDefaultsState: IDefaultsState = {
  defaults: [],
}

export function defaultsReducer(state: IDefaultsState = initialDefaultsState, action: IDefaultsAction): IDefaultsState {
  switch (action.type) {
    case DefaultsConstants.SET_PROCEDURE_DEFAULTS:
      return { ...state, defaults: action.defaults }
    default:
      return state
  }
}
